import React, { useEffect, useState } from 'react';
import { message } from 'antd';

import ChooseTime from './components/chooseTime';
import RowTable from './components/rowTable';
import LineChart from './components/lineChart';
import PieChart from './components/pieChart';
import { orderCountIndicator } from '@/services/chartData';
const OrderCountData = () => {
  const [rowTableData1, setRowTableData1] = useState([]);
  const [rowTableData2, setRowTableData2] = useState([]);
  const [pieData, setPieData] = useState([]);
  const [lineData, setLineData] = useState([]);
  const [timeRadioValue, setTimeRadioValue] = useState('month');
  const [timeRangeValue, setTimeRangeValue] = useState(['', '']);
  const queryOrderCountData = () => {
    let requestData = {};
    if (timeRadioValue === 'date') {
      requestData = {
        startDate: timeRangeValue[0],
        endDate: timeRangeValue[1],
      };
    } else {
      requestData = {
        quickQuery: timeRadioValue,
      };
    }
    orderCountIndicator({
      requestData: requestData,
    }).then(({ code, msg, data }) => {
      if (code === '00000') {
        setDatas(data);
      } else {
        message.error(msg);
      }
    });
  };
  const setDatas = (data) => {
    setRowTableData1([
      {
        title: '总数',
        value: data.totalCount,
        isTailDivider: true,
      },
      {
        title: '0元单',
        value: data.zeroCount,
        isTailDivider: true,
      },
      {
        title: '正式付费单（支付金额>0.1元）',
        value: data.formalCount,
        isTailDivider: true,
      },
      {
        title: '试用单（0<支付金额<=0.1元）',
        value: data.tryCount,
      },
    ]);
    setRowTableData2([
      {
        title: '商家会员月卡',
        value: data.liteMonthCount,
        isTailDivider: true,
      },
      {
        title: '商家会员年卡',
        value: data.liteAnnualCount,
        isTailDivider: true,
      },
      {
        title: 'PRO',
        value: data.aiCount,
        isTailDivider: true,
      },
      {
        title: '商家SP',
        value: data.tenantSpCount,
        isTailDivider: true,
      },
      {
        title: '包月私教',
        value: data.tenantCustomizeCount,
        isTailDivider: true,
      },
      {
        title: 'API直冲付费',
        value: data.apiPayCount,
        isTailDivider: true,
      },
      {
        title: '联合营销正式付费',
        value: data.coMarketingFormalCount,
        isTailDivider: true,
      },
      {
        title: '联合营销试用',
        value: data.coMarketingTryCount,
      },
    ]);
    setPieData([
      {
        title: '0元单',
        value: Number(data.zeroCount),
      },
      {
        title: '正式付费单（支付金额>0.1元）',
        value: Number(data.formalCount),
      },
      {
        title: '试用单（0<支付金额<=0.1元）',
        value: Number(data.tryCount),
      },
    ]);
    let arr = [];
    arr = arr
      .concat(
        data.littaMonthCountTrend.map((i) => {
          return {
            ...i,
            category: 'LITTA月卡',
          };
        }),
      )
      .concat(
        data.littaAnnualCountTrend.map((i) => {
          return {
            ...i,
            category: 'LITTA年卡',
          };
        }),
      )
      .concat(
        data.liteMonthCountTrend.map((i) => {
          return {
            ...i,
            category: '商家会员月卡',
          };
        }),
      )
      .concat(
        data.liteAnnualCountTrend.map((i) => {
          return {
            ...i,
            category: '商家会员年卡',
          };
        }),
      )
      .concat(
        data.aiCountTrend.map((i) => {
          return {
            ...i,
            category: 'PRO订单数趋势',
          };
        }),
      );
    setLineData(arr);
  };
  useEffect(() => {
    queryOrderCountData();
  }, [timeRadioValue, timeRangeValue]);
  const handleTimeChange = (type, value) => {
    if (type === 'date' && value) {
      setTimeRangeValue(value);
    }
    setTimeRadioValue(type);
  };
  return (
    <div>
      <ChooseTime
        timeRadioValue={timeRadioValue}
        onTimeChange={handleTimeChange}
      />
      <RowTable rowTableData={rowTableData1} title="订单构成" />
      <RowTable rowTableData={rowTableData2} title="付费订单数据" />
      <PieChart pieData={pieData} />
      <LineChart
        lineData={lineData}
        xField="abscissa"
        yField="ordinate"
        seriesField="category"
      />
    </div>
  );
};

export default OrderCountData;
